export default __webpack_public_path__ + "static/media/bathroom-mid_Knauf_W112-H2-A13.8dea40e3.jpg";